<template>
      <div class="respondent-download">
          <a
            href="#"
            @click.prevent="downloadItem()"
            id="DownloadCompleteSurveyData"
            :class="[this.inputDisableDownloadButton ? 'btn btn-primary float-right mb-4' : 'btn btn-primary float-right mb-4 disabled']"
            role="button"
            aria-disabled="true"
          >
            <span class="align-text-bottom">Download Survey Data <font-awesome-icon :icon="['fa', 'download']"/></span>
            <span v-show="$parent.getModalLoading()" class="mb-1 align-text-bottom spinner-border spinner-border-sm"></span>
          </a>
          <div class="form-group p-2 float-right d-flex align-items-center m-0" style="line-height: normal;">
            <span class="mr-2">Include:</span>
            <div class="form-check form-check-inline d-flex align-items-center m-0">
              <input
                type="checkbox"
                class="form-check-input position-static m-0 mr-1"
                id="includeOpens"
                name="includeOpens"
                v-model="includeOpens"
              />
              <label class="custom-checkout m-0 mr-2" for="includeOpens">Opens</label>
            </div>
            <div class="form-check form-check-inline d-flex align-items-center m-0">
              <input
                type="checkbox"
                class="form-check-input position-static m-0 mr-1"
                id="includeCompletes"
                name="includeCompletes"
                v-model="includeCompletes"
              />
              <label class="custom-checkout m-0 mr-2" for="includeCompletes">Completes</label>
            </div>
            <div class="form-check form-check-inline d-flex align-items-center m-0">
              <input
                type="checkbox"
                class="form-check-input position-static m-0 mr-1"
                id="includePartials"
                name="includePartials"
                v-model="includePartials"
              />
              <label class="custom-checkout m-0 mr-2" for="includePartials">Partials</label>
            </div>
            <div class="form-check form-check-inline d-flex align-items-center m-0">
              <input
                type="checkbox"
                class="form-check-input position-static m-0 mr-1"
                id="includeEditedData"
                name="includeEditedData"
                v-model="includeEditedData"
              />
              <label class="custom-checkout m-0 mr-2" for="includeEditedData"><modal-link modal-id="Edited Data File" :content-list="pageContent" :image-size="'small'"></modal-link>Edited Data File</label>
            </div>
            <div class="form-check form-check-inline d-flex align-items-center m-0">
              <input
                type="checkbox"
                class="form-check-input position-static m-0 mr-1"
                id="includeQualityGrades"
                name="includeQualityGrades"
                v-model="includeQualityGrades"
              />
              <label class="custom-checkout m-0" for="includeQualityGrades">Quality Grades</label>
            </div>
          </div>            
      </div>
</template>
<script>
import UserSettingsService from "../services/user.settings.service";
import UserService from "../services/user.service";
import AdminService from "../services/admin.service";
import ErrorService  from "../services/error.service";
import SurveySummaryService from "../services/survey.summary.service";
import ViewMixins from "../mixins/ViewMixins.vue";
import ContentMixins from "../mixins/ContentMixins.vue";

export default {
  name: "DownloadSurveyData",
  mixins: [ViewMixins, ContentMixins],
  data() {
    return {
        includeOpens: false,
        includeCompletes: true,
        includePartials: false,
        includeEditedData: false,
        includeQualityGrades: false,
        title: "Survey Data"
    };
  },
  methods: {
    processUserSettings: function (response) {
      let statusCode = response.data.statusCode;
      if (statusCode == 200) {
        let userSettings = response.data.data;
        var inputIncludeQualityGrades = userSettings.find((x) => x.userSettingTypeName == "include-quality-grades");
        if (typeof inputIncludeQualityGrades != "undefined") {
          this.includeQualityGrades = inputIncludeQualityGrades.userSettingValue == "Y" ? true : false;
        }        
      }
    },    
    async downloadItem() {
      this.processingComplete = false;
      this.$parent.setupDownloadItem();
      const timer = setTimeout(() => {
        if (this.processingComplete == false || this.processingComplete == "false") {
          this.processingComplete = true;
          AdminService.displayInfoMessage({ text: "Processing is taking more than usual. The file will be sent via email.", duration: -1 });
		      this.$parent.setModalLoading(false);
          this.$root.setLoading(false);
        }
      }, 60000);
      await SurveySummaryService.getDownloadSurveyDataUrlMultiple(
			this.inputDownloadSets, this.includeQualityGrades, this.inputSurveyGroupId, this.includeOpens, this.includeCompletes, this.includePartials, this.includeEditedData, this.getDownloadSurveyDataUrlMultipleCallback, this);
      clearTimeout(timer);
    },
    getDownloadSurveyDataUrlMultipleCallback(response) {
      // If processing time is less than a 1 minute, file will be downloaded. 
      // Else it'll be sent through email from server side.
      if (this.processingComplete == false || this.processingComplete == "false") {
        this.processingComplete = true;
        this.$parent.downloadItemCallback(response);
      }
    },
    downloadItemError(error) {
      AdminService.displayErrorMessage({ text: "Error Downloading the file" });
      ErrorService.processError("DownloadSurveyData.downloadItem", error, "survey-status", this);
      this.$gtag.exception("Error Downloading the file");
    },
  },
  umnounted() {},
  computed: {},
  mounted() {
    UserSettingsService.getUserSettingsFromDatabase(UserService.getUserId(),  UserService.getUserCode(), this.processUserSettings, this);
    this.getPageContentByPage(this.title);
  },
  watch: {},
  props: {
    inputDownloadSets: {
      type: Array,
      default() {
            return []
        }
    },
    inputSurveyGroupId: {
      type: Number,
      default: 0,
    },
    inputDisableDownloadButton: {
      type: Boolean,
      default: false,
    },
  }
};
</script>
